<template>
  <div class="Exporthk8">
    <v-row>
      <v-col class="text-right">
        <!-- <v-btn
          type="button"
          @click="
            exportexcelhk8(
              tokenexport,
              exportthn,
              exportbln,
              exportps,
              paparnegeriexport
            )
          "
          color="blue white white--text"
        >
          <span class="material-icons">file_download</span>
          {{ $t("muatturun") }} {{ $t("hk8") }}
        </v-btn> -->
         <download-excel
              :data = "papardatahk8"
              type="csv"
              name="hk8.xls"
              >
              <v-btn type="button" color="blue white white--text">
                <span class="material-icons">file_download</span>
                {{ $t("muatturun") }} {{ $t("hk8") }}
              </v-btn>
            </download-excel>
      </v-col>
    </v-row>
    &nbsp;
    <v-row>
      <v-col cols="12" sm="12">
        <v-data-table
          :headers="headers"
          :items="papardatahk8"
          :items-per-page="10"
          class="elevation-1"
          height="500"
          fixed-header
        >
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
// import i18n from "@/i18n";
// import hidServices from "@/services/lookupField";
// const lookup = new hidServices();
import axios from "../../plugins/axios";
import Vue from 'vue';
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  Name: "Exporthk8",
  setup() {},
  props: [
    "papardatahk8",
    "exportthn",
    "exportbln",
    "exportps",
    "paparnegeriexport",
  ],
  mounted() {},
  data: () => ({
    tokenexport: window.localStorage.getItem("tokenexport"),
    databatch: "",
    headers: [
      {text: "Bil", value: "Bil"},
      {text: "HID", value: "HID"},
      {text: "BNO", value: "BNO"},
      {text: "Pusingan", value: "Pusingan"},
      {text: "S", value: "S"},
      {text: "NG", value: "NG"},
      {text: "DP", value: "DP"},
      {text: "DB", value: "DB"},
      {text: "BP", value: "BP"},
      {text: "ST", value: "ST"},
      {text: "NOIR", value: "NOIR"},
      {text: "NOAIR", value: "NOAIR"},
      // {text: "KAW", value: "KAW"},
      // {text: "P", value: "P"},
      // {text: "Bulan", value: "Bulan"},
      // {text: "Tahun", value: "Tahun"},
      {text: "S75", value: "S75"},
      {text: "INCS22_1", value: "INCS22_1"},
      {text: "INCS22_2", value: "INCS22_2"},
      {text: "S78i", value: "S78i"},
      {text: "S78ii", value: "S78ii"},
      {text: "S78iii", value: "S78iii"},
      {text: "INCS22_3", value: "INCS22_3"},
      {text: "INCS22", value: "INCS22"},
      {text: "S80", value: "S80"},
      {text: "INCS23_1", value: "INCS23_1"},
      {text: "INCS23_2", value: "INCS23_2"},
      {text: "INCS23_3", value: "INCS23_3"},
      {text: "S84i", value: "S84i"},
      {text: "S84ii", value: "S84ii"},
      {text: "S84iii", value: "S84iii"},
      {text: "INCS23_4", value: "INCS23_4"},
      {text: "INCS23", value: "INCS23"},
      {text: "S86", value: "S86"},
      {text: "INCS24", value: "INCS24"},
      {text: "S88", value: "S88"},
      {text: "INCS23_b_3ii", value: "INCS23_b_3ii"},
      {text: "INCS23_b_3iii", value: "INCS23_b_3iii"},
      {text: "INCS23_b", value: "INCS23_b"},
      {text: "INCS23_c_1", value: "INCS23_c_1"},
      {text: "INCS23_c_2", value: "INCS23_c_2"},
      {text: "INCS23_c_3", value: "INCS23_c_3"},
      {text: "INCS23_c_3i", value: "INCS23_c_3i"},
      {text: "INCS23_c_3ii", value: "INCS23_c_3ii"},
      {text: "INCS23_c_3iii", value: "INCS23_c_3iii"},
      {text: "INCS23_c", value: "INCS23_c"},
      {text: "INCS23_d_1", value: "INCS23_d_1"},
      {text: "INCS23_d_2", value: "INCS23_d_2"},
      {text: "INCS23_d_3", value: "INCS23_d_3"},
      {text: "INCS23_d_4", value: "INCS23_d_4"},
      {text: "INCS23_d_4i", value: "INCS23_d_4i"},
      {text: "INCS23_d_4ii", value: "INCS23_d_4ii"},
      {text: "INCS23_d_4iii", value: "INCS23_d_4iii"},
      {text: "INCS23_d", value: "INCS23_d"},
      {text: "INCS23_e_1", value: "INCS23_e_1"},
      {text: "INCS23_e_2", value: "INCS23_e_2"},
      {text: "INCS23_e_3", value: "INCS23_e_3"},
      {text: "INCS23_e_3i", value: "INCS23_e_3i"},
      {text: "INCS23_e_3ii", value: "INCS23_e_3ii"},
      {text: "INCS23_e_3iii", value: "INCS23_e_3iii"},
      {text: "INCS23_e", value: "INCS23_e"},
      {text: "INCS32a_1", value: "INCS32a_1"},
      {text: "S90i", value: "S90i"},
      {text: "S90ii", value: "S90ii"},
      {text: "INCS32a_2", value: "INCS32a_2"},
      {text: "INCS32a", value: "INCS32a"},
      {text: "S92", value: "S92"},
      {text: "INCS32b_1", value: "INCS32b_1"},
      {text: "INCS32b_2", value: "INCS32b_2"},
      {text: "S94i", value: "S94i"},
      {text: "S94ii", value: "S94ii"},
      {text: "S94iii", value: "S94iii"},
      {text: "INCS32b", value: "INCS32b"},
      {text: "INCS32", value: "INCS32"},
      {text: "INCS31", value: "INCS31"},
      {text: "INCS33", value: "INCS33"},
      {text: "INCS34", value: "INCS34"},
    ],
  }),
  methods: {
    async exportexcelhk8(
      tokenexport,
      exportthn,
      exportbln,
      exportps,
      paparnegeriexport
    ) {
      try {
        await axios
          .post(`${process.env.VUE_APP_API_URL}/sec/checksession`, {
            tokenexportsess: window.localStorage.getItem("tokenexport"),
          })
          .then((result) => {
            console.log(result.data.status);
            if (result.data.status) {
              window.open(
                `${process.env.VUE_APP_API_URL}/HK/exporthk8serverside/${tokenexport}/${exportthn}/${exportbln}/${exportps}/${paparnegeriexport}/`,
                "_blank"
              );
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>